<template>
  <div class="learn-records-box">
    <ul class="learn-info-list">
      <li class="learn-info-li">
        <div class="info-top">
          <div class="info-top-left">
            <p>已学课程</p>
            <el-popover
              placement="top"
              width="180"
              trigger="hover"
              :content="'已学习完成的课程数量'"
            >
              <img
                slot="reference"
                src="../../assets/images/operateData/question-icon.png"
                alt
                class="question-icon"
              />
            </el-popover>
            <!-- <img src="../../assets/images/operateData/question-icon.png" alt /> -->
          </div>
          <img
            src="../../assets/images/create-college/record-icon1.png"
            alt=""
            class="record-icon"
          />
        </div>
        <div class="info-bottom">
          <span>{{ courseNum }}</span>
          <i>节</i>
        </div>
      </li>
      <li class="learn-info-li">
        <div class="info-top">
          <div class="info-top-left">
            <p>累计学习时长</p>
            <el-popover
              placement="top"
              width="180"
              trigger="hover"
              :content="'累计学习课程的总时长'"
            >
              <img
                slot="reference"
                src="../../assets/images/operateData/question-icon.png"
                alt
                class="question-icon"
              />
            </el-popover>
            <!-- <img src="../../assets/images/operateData/question-icon.png" alt /> -->
          </div>
          <img
            src="../../assets/images/create-college/record-icon2.png"
            alt=""
            class="record-icon"
          />
        </div>
        <div class="info-bottom">
          <span>{{ courseTimeTotal }}</span>
          <i>分</i>
        </div>
      </li>
    </ul>
    <div class="record-header">
      <h5 class="record-title">学习记录</h5>
      <p>
        共<span>{{ total }}</span
        >个课程
      </p>
    </div>
    <div v-if="total > 0" class="course-list">
      <courseItem
        v-for="item in recordsList"
        :key="item.lessonId"
        :info="item"
        :currentTab="3"
        @refresh="refreshData"
      />
    </div>
    <div v-else class="no-data">
      <img src="../../assets/images/create-college/not-data.png" alt="" />
      <p>空空如也，暂无学习记录</p>
    </div>
    <div v-if="total > 10" class="pagination-box">
      <el-pagination
        background
        layout="prev, pager, next, jumper"
        :page-size="pageSize"
        :total="total"
        :current-page.sync="pageIndex"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../../assets/js/api";
import courseItem from "./course-item.vue";
export default {
  name: "ShopCenterAdminWebLearnRecords",
  components: {
    courseItem,
  },
  props: {
    keyword: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      recordsList: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      courseNum: 0,
      courseTimeTotal: 0,
    };
  },
  watch: {
    keyword: {
      handler() {
        this.getRecordsList();
      },
    },
  },
  mounted() {
    this.getRecordsStatistics();
    this.getRecordsList();
  },

  methods: {
    async getRecordsStatistics() {
      const res = await this.$axios.get(
        api.creatCollege.getRecordsStatistics +
          "?shopId=" +
          this.$store.state.user.userInfo.shopId
      );
      if (res.valid) {
        this.courseNum = res.result.lessonNum;
        this.courseTimeTotal = Math.floor(res.result.lessonTimeTotal / 60);
      }
    },
    async getRecordsList() {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      if (this.keyword) {
        params.title = this.keyword;
      }
      const res = await this.$axios.post(
        api.creatCollege.getRecordsList,
        params
      );
      if (res.valid) {
        this.recordsList = res.result.list;
        this.total = res.result.totalCount;
      }
    },
    changePage() {
      this.getRecordsList();
    },
    // 刷新数据
    refreshData() {
      this.getRecordsStatistics();
      this.getRecordsList();
    },
  },
};
</script>

<style lang="scss" scoped>
.learn-records-box {
  min-width: 1080px;
  padding: 60px 40px;
  border-radius: 5px;
  background: #fff;
  .learn-info-list {
    display: flex;
    align-items: center;
    justify-content: center;
    .learn-info-li {
      width: 230px;
      height: 80px;
      padding: 10px 20px;
      margin-right: 25px;
      border-radius: 5px;
      border: 1px solid #dddfe6;
      background: #fff;
      &:last-child {
        margin-right: 0;
      }
      .info-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        .info-top-left {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          & > p {
            color: #606266;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 14px;
          }
          ::v-deep .el-popover__reference-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .question-icon {
            width: 16px;
            height: 16px;
            margin-left: 5px;
            cursor: pointer;
          }
        }
        .record-icon {
          width: 26px;
          height: 26px;
        }
      }
      .info-bottom {
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;
        & > span {
          margin-right: 4px;
          color: #3a3d4b;
          text-align: center;
          font-size: 34px;
          font-style: normal;
          font-weight: 700;
          line-height: 1;
        }
        & > i {
          transform: translateY(-4px);
          color: #3b3f52;
          text-align: center;
          font-size: 16px;
          font-style: normal;
          font-weight: 700;
          line-height: 1;
        }
      }
    }
  }
  .record-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 60px 0 20px;
    .record-title {
      color: #3a3d4b;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: 18px;
    }
    & > p {
      color: #80848b;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px;
      & > span {
        color: #6384f7;
      }
    }
  }

  .course-list {
    display: grid;
    grid-template-columns: repeat(5, 18.2%);
    grid-template-rows: 240px;
    column-gap: 2%;
    row-gap: 30px;
    grid-auto-rows: 240px;
  }
  .no-data {
    height: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    & > img {
      width: 160px;
      height: 208px;
      margin-bottom: 22px;
    }
    & > p {
      color: #999;
      text-align: center;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
  .pagination-box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 30px;
  }
}
</style>
